"use client";

import style from "./style.css";
import { useContent } from "../../content/current";

export default function Loader() {
  const content = useContent();
  

  return (
   <>
   <div id="loader">
    <img src="/loader.svg" alt=""></img>
    <div id="loaderbar"></div>
    <div id="percent"><span>0</span>%</div>
    </div>
    <div id="discover">
      <span>
      {content.loader.scroll}
      </span>
      </div>
      <div id="copyright">{content.loader.copyrightPrefix} {new Date().getFullYear()} {content.loader.copyrightName}</div>
   </>
  );
}
